<convfact-creditos-con-empleados-form [creditosConEmpleados]="creditosConEmpleados" (onSave)="saveData($event)">
</convfact-creditos-con-empleados-form>
